import { combineReducers } from 'redux';

import delay from './delay';
import done from './done';

const actions = combineReducers({
  delay,
  done,
});

export default actions;
